import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TransferData {

    public transPagestorage: any;
    public pastdueautopay:any;

    public constructor() { }

}